import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RfidFileDeleteDialog from './RfidFileDeleteDialog';
import ManualPreadviceTransactionsDeleteDialog from '../../../impc-stock-levels/transactions/manual-preadvice/delete/containers/ManualPreadviceTransactionsDeleteDialog';

class RfidFileDelete extends Component {
  render() {
    return (
      <div>
        <RfidFileDeleteDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
        />
      </div>
    );
  }
}

RfidFileDelete.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
};

export default RfidFileDelete;
